







import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '../store/eplmodule'

@Component({ name: 'ShowError' })
export default class ShowError extends Vue {
  get showerror (): boolean {
    if (EPLModule.errormessage !== '') return true
    return false
  }

  get errormessage (): string {
    if (EPLModule.errormessage.includes('recepient')) EPLModule.setError('')
    return EPLModule.errormessage
  }

  private clearError () {
    EPLModule.setError('')
  }
}
